module.exports = __webpack_public_path__ + "img/step5.d96ea388.png";